// extracted by mini-css-extract-plugin
export default {"header":"PoleEducation_header__04Hdx","contentContainer":"PoleEducation_contentContainer__9-Xlh"};